"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TryUpdateChainMsg = void 0;
const router_1 = require("@keplr-wallet/router");
const constants_1 = require("./constants");
class TryUpdateChainMsg extends router_1.Message {
    constructor(chainId) {
        super();
        this.chainId = chainId;
    }
    static type() {
        return "try-update-chain";
    }
    validateBasic() {
        if (!this.chainId) {
            throw new router_1.KeplrError("updater", 100, "Empty chain id");
        }
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return TryUpdateChainMsg.type();
    }
}
exports.TryUpdateChainMsg = TryUpdateChainMsg;
//# sourceMappingURL=messages.js.map